<template>
	<div v-if="pageDataStatus === 'success'"
		 class="outer-page">
		<div ref="innerPageRef"
			 class="inner-page">
			<main>
				<DirectusBlocks v-for="block in pageData?.blocks"
								:key="block.id"
								:data="block" />
			</main>
		</div>
	</div>

	<div v-else
		 class="outer-page">
		<div ref="innerPageRef"
			 class="inner-page">
			Loading...
		</div>
	</div>
</template>

<script setup>
const { directus, readSingleton } = useDirectus()
const { $bus } = useNuxtApp()
const metaStore = useMetaStore()
const config = useRuntimeConfig()
const url = '/'

const { data: pageData, status: pageDataStatus } = await useAsyncData('homepage', () => {
	return directus.request(readSingleton('homepage', homepagesQuery()))
})

useSuperSeoMeta(pageData.value, { ...config, url })

const innerPageRef = ref(null)

function initComponent() {
	metaStore.setActivePageColors(pageData.value)

	$bus.$emit('page-mounted')
}

onMounted(() => {
	$bus.$emit('header-set-height')

	useAnims(initComponent)
	useCssAnims(innerPageRef.value)
})
</script>

<style lang="scss" scoped>
.inner-page {
	padding-top: 0;
}

.request-full-portfolio {
	@include universal-side-padding;
	align-content: flex-end;
	text-align: right;
	overflow-x: hidden;
	margin-top: rem-calc(-100) * 0.5;

	@include for-devices-above(md) {
		margin-top: rem-calc(-140)* 0.5;
	}

	@include for-devices-above(xl) {
		margin-top: rem-calc(-200)* 0.5;
	}

	.button-safe-wrap {
		margin-top: calc((3rem * 1));
		margin-bottom: calc((3rem * 1));
	}
}
</style>